import React from 'react';

const VideoShowcase = () => {
  return (
    <section className="relative bg-[#1f2a20] overflow-hidden">
      <div className="relative w-full">
        <div className="relative w-full aspect-video max-h-[92vh]">
          <video
            src="https://customer-assets.emergentagent.com/job_stable-modern/artifacts/ag1n3kjw_Lena%20reklam.mp4"
            poster="https://customer-assets.emergentagent.com/job_stable-modern/artifacts/oi9euftu_lenas%20bilder%201010.jpeg"
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            className="w-full h-full object-cover"
          />
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#1f2a20]/40 via-transparent to-[#1f2a20]/10" />
        </div>

        <div className="absolute top-8 md:top-12 left-0 right-0 flex justify-center pointer-events-none">
          <p className="text-[#e8d8b4] text-[11px] md:text-xs uppercase tracking-[0.4em] font-medium">
            — Reklamfilm
          </p>
        </div>

        <div className="absolute bottom-8 md:bottom-14 left-0 right-0 px-6 md:px-10 pointer-events-none">
          <div className="max-w-7xl mx-auto">
            <h3 className="font-display text-[#faf7f2] text-3xl md:text-5xl lg:text-6xl leading-[1.05] drop-shadow-[0_4px_24px_rgba(0,0,0,0.4)]">
              En liten film <em className="italic font-light text-[#e8d8b4]">från fjället</em>.
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoShowcase;
